export const parseFlagEnumValue = <const T extends readonly string[]>(
  value: string,
  values: T,
  fallback: T[number],
): T[number] => {
  return values.includes(value) ? value : fallback;
};
